import { render, staticRenderFns } from "./AutocompleteOrganizers.vue?vue&type=template&id=59c6879d&scoped=true&lang=pug"
import script from "./AutocompleteOrganizers.vue?vue&type=script&lang=js"
export * from "./AutocompleteOrganizers.vue?vue&type=script&lang=js"
import style0 from "./AutocompleteOrganizers.vue?vue&type=style&index=0&id=59c6879d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c6879d",
  null
  
)

export default component.exports